export default "__VITE_ASSET__DEK7iW2l__"